export default {
    install(Vue) {
        Vue.Account = {
            ADMIN: 1,
            MUNICIPAL: 2,
            SHOP: 3
        }
    }
};
